export const STATUS = {
  DRAFT: 'draft',
  PAID: 'paid',
  UNPAID: 'unpaid',
  CANCELED: 'canceled',
} as const;

export const ATTACHMENTS = {
  ATTACHMENT: 'attachment',
  TERMS_CONDITIONS: 'terms-conditions',
};
